import styled from '@emotion/styled';
import { MenuItem, Typography, useDevice } from '@innovamat/glimmer-components';
import type { IconType } from '@innovamat/glimmer-icons';
import { useTranslation } from 'react-i18next';
import { useMySettings } from '../providers/my-settings-provider';
import type { SettingsTabType } from '../types';

const LateralMenu = styled.div`
  padding-top: 24px;
  padding-right: 32px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    padding-right: 0;
    width: 100%;
  }
`;

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Title = styled(Typography.Body1)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
`;

export function MySettingsMenu(): JSX.Element {
  const { t } = useTranslation();
  const { changeActiveTab, isTabActive, getTitle, availableTabs, activeTab } =
    useMySettings();
  const { isMobile } = useDevice();
  const iconMap: Record<SettingsTabType, IconType> = {
    PersonalData: 'UserIcon',
    Password: 'PasswordIcon',
    Email: 'MailIcon',
    SchoolData: 'DataIcon',
    Language: 'LanguageIcon',
  };
  return (
    <LateralMenu>
      <Title>{t('settings')}</Title>
      <TabsWrapper>
        {availableTabs.map((tab) => (
          <MenuItem
            icon={iconMap[tab]}
            text={getTitle(tab)}
            fill
            state={!isMobile && isTabActive(tab) ? 'selected' : 'active'}
            onClick={() => changeActiveTab(tab)}
            rightIcon={isMobile ? 'NextIcon' : undefined}
            key={tab}
            size="L"
            dataTestId={`my-settings-menu-${tab}`}
          />
        ))}
      </TabsWrapper>
    </LateralMenu>
  );
}
